import { useEffect, useState } from 'react'

import type { LinkType } from 'types'
import { fetchSeminarPrice } from 'services/seminars'
import Loader from 'content-components/_Primatives/Loader'
import SidebarEventModule from 'ui-component-library/components/Sidebar/EventModule'
import { useSelector } from 'react-redux'
import { getTrainingLanguageStrings } from 'store/strings/selectors'

type Props = {
  id: string
  name: string
  location?: {
    address: string
    city: string
    country: string
    postalCode: string
    state?: string
  }
  mapLinkText: string
  websiteLink?: LinkType
  date: string
  language: 'en' | 'fr-FR' | 'pt-BR'
  isOnlineSeminar: boolean
  contactText?: string
  isAvailable: boolean
  isWaitlisted: boolean
  registerLink: LinkType
  registrationOpenStatusText: string
  registrationStatusLabelText: string
  registrationText: string
  registrationWaitingStatusText: string
  revalidationText: string
  revalidationPrice?: string
  currency: string
  currencySymbol: string
  eventSummaryText: string
  locationSummaryText: string
}

function SidebarEventModuleContainer({
  id,
  currencySymbol,
  currency,
  ...props
}: Props) {
  const { name, isOnlineSeminar } = props
  const languageStrings = useSelector(getTrainingLanguageStrings)
  const [registrationPrice, setRegistrationPrice] = useState<string>()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (isOnlineSeminar && name.startsWith('Online Level 1')) {
      setRegistrationPrice('$1000 USD')
      setIsLoading(false)
    } else {
      fetchSeminarPrice(id).then((price) => {
        setRegistrationPrice(`${currencySymbol}${price} ${currency}`)
        setIsLoading(false)
      })
    }
  }, [])

  if (isLoading) {
    return <Loader />
  }

  return (
    <SidebarEventModule
      {...props}
      languageStrings={languageStrings}
      registrationPrice={registrationPrice}
    />
  )
}

export default SidebarEventModuleContainer
